"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ConditionalHelper_1 = require("../helpers/ConditionalHelper");
var Query_1 = require("./Query");
var BaseQuery_1 = require("./BaseQuery");
var typeChecks_1 = require("../utils/typeChecks");
exports.MAX_CALL_STACK_LEVEL = 50;
var BaseEntityQuery = /** @class */ (function (_super) {
    __extends(BaseEntityQuery, _super);
    function BaseEntityQuery(queryOptions, translationHelper) {
        return _super.call(this, queryOptions, translationHelper) || this;
    }
    BaseEntityQuery.prototype.getSubCollection = function (executionOptions) {
        var queryOptionsType = this.queryOptions.queryOptionsType;
        return this.processEntities(executionOptions, function (entity) {
            if (entity && entity[queryOptionsType]) {
                return entity[queryOptionsType];
            }
        });
    };
    BaseEntityQuery.prototype.processEntities = function (executionOptions, processingFunction) {
        var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({ conditions: [] }, this.translationHelper);
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        if (context) {
            var entityByType = context.entityByType, documentEntityByKeys = context.documentEntityByKeys;
            var _a = this.options, entityType = _a.entityType, entityConditional_1 = _a.entityConditional, documentEntityKey = _a.documentEntityKey, entityKey = _a.entityKey, entityIndex = _a.entityIndex;
            var entities = [];
            if (entityKey) {
                entities = this.getLinkedEntities(entityKey, context, entityIndex);
                if (entities && entityConditional_1) {
                    entities = entities.filter(function (entity) { return conditionalHelper.matches(entity, entityConditional_1, executionOptions); });
                }
            }
            else {
                var documentEntity = documentEntityByKeys && documentEntityKey && documentEntityByKeys[documentEntityKey];
                var entity = documentEntity || (entityByType && entityType && entityByType[entityType]);
                if (entity && (!entityConditional_1 || conditionalHelper.matches(entity, entityConditional_1, executionOptions))) {
                    entities = [entity];
                }
            }
            var processingResults = [];
            for (var _i = 0, entities_1 = entities; _i < entities_1.length; _i++) {
                var entity = entities_1[_i];
                processingResults.push(processingFunction(entity));
            }
            return processingResults.length === 0 ? undefined :
                processingResults.length === 1 ? processingResults[0] :
                    processingResults;
        }
        return;
    };
    BaseEntityQuery.prototype.getEntities = function (executionOptions, context) {
        var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({ conditions: [] }, this.translationHelper);
        if (context) {
            var entities = context.entities;
            var queryId = this.queryOptions.queryId;
            var entityConditional_2 = this.options.entityConditional;
            var entitiesContext = (entities && queryId && entities[queryId]);
            if (entitiesContext) {
                return entitiesContext.values.filter(function (entity) { return (!entityConditional_2 || conditionalHelper.matches(entity, entityConditional_2, executionOptions)); });
            }
        }
        return;
    };
    BaseEntityQuery.prototype.getLinkedEntities = function (entityKey, context, entityIndex) {
        var entityMap = context.entityMap, entitiesById = context.entitiesById;
        if (entityMap && entityKey && entityMap[entityKey]) {
            var linkedEntitiesIds = entityMap[entityKey];
            var linkedEntities_1 = [];
            if (!typeChecks_1.isNullOrUndefined(entityIndex)) {
                var linkedEntityId = Array.from(linkedEntitiesIds)[entityIndex];
                if (linkedEntityId) {
                    linkedEntities_1.push(entitiesById.get(linkedEntityId));
                    return linkedEntities_1;
                }
                console.warn("getLinkedEntities: No entity id found at childIndex of " + entityIndex + " for entityKey \"" + entityKey + "\". Using all linked entities");
            }
            linkedEntitiesIds.forEach(function (linkedEntityId) {
                linkedEntities_1.push(entitiesById.get(linkedEntityId));
            });
            return linkedEntities_1;
        }
        return [];
    };
    return BaseEntityQuery;
}(BaseQuery_1.BaseQuery));
exports.BaseEntityQuery = BaseEntityQuery;
//# sourceMappingURL=BaseEntityQuery.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/query/BaseEntityQuery.js
// module id = 180
// module chunks = 1